import AppSettings from './app.settings';
export default function AppSettingsService($ngRedux) {
  'ngInject';
  const getDateFormat = () => {
    if ($ngRedux) {
      const {
        user: {dateFormat = 'YYYY/MM/DD'}
      } = $ngRedux.getState();
      return dateFormat;
    }
    return 'YYYY/MM/DD';
  };

  return {
    ...AppSettings,
    InReachApiEndpoint: '/',
    InReachApiTransfersEndpoint: '/transfers',
    InReachApiTimeSeriesEndpoint: '/series',
    InReachApiCSVExportEndpoint: '/export',
    InReachApiSavedFilterEndpoint: '/savedfilter',
    InReachApiSearchFavouritesEndpoint: '/search/favourites',
    InReachMediaEndpoint: '/media',
    InReachApiSchedulerEndpoint: '/scheduler',
    InReachApiReportEndpoint: '/reports',
    InReachApiGeozonesEndpoint: '/geozones',
    InReachApiProductsEndpoint: '/products',
    InReachApiPackagesEndpoint: '/packages',
    InReachApiInstallationsEndpoint: '/installations',
    InReachApiEquipmentEndpoint: '/equipment',
    InReachApiAlertsEndpoint: '/alerts',
    InReachApiBulkActivation: '/bulkactivation',
    GetDateFormat: getDateFormat
  };
}
